/**
 * Mirrors the backend `App\Enums\AiChat\LayeringType` enum. Only TEXT layering exists today;
 * new layering types get a new case here and on the PHP side.
 *
 * Lives in `@Libraries` (not the ai-chat feature lib) so both the ai-chat components and the
 * poster-whiteboard domain can reference it without a component→domain dependency.
 */
export enum LayeringType {
  TEXT = 'text',
}
